import { useEffect } from "react";

export function useTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | ScottDB.Net` : "ScottDB.Net";
  }, [title]);
}
